<template>
  <div>
    <template v-if="!production">
      <b-form-group label="Table Options" label-cols-lg="2" v-slot="{ ariaDescribedby }">
        <b-form-checkbox v-model="striped" :aria-describedby="ariaDescribedby" inline>Striped</b-form-checkbox>
        <b-form-checkbox v-model="bordered" :aria-describedby="ariaDescribedby" inline>Bordered</b-form-checkbox>
        <b-form-checkbox v-model="borderless" :aria-describedby="ariaDescribedby" inline>Borderless</b-form-checkbox>
        <b-form-checkbox v-model="outlined" :aria-describedby="ariaDescribedby" inline>Outlined</b-form-checkbox>
        <b-form-checkbox v-model="small" :aria-describedby="ariaDescribedby" inline>Small</b-form-checkbox>
        <b-form-checkbox v-model="hover" :aria-describedby="ariaDescribedby" inline>Hover</b-form-checkbox>
        <b-form-checkbox v-model="dark" :aria-describedby="ariaDescribedby" inline>Dark</b-form-checkbox>
        <b-form-checkbox v-model="fixed" :aria-describedby="ariaDescribedby" inline>Fixed</b-form-checkbox>
        <b-form-checkbox v-model="footClone" :aria-describedby="ariaDescribedby" inline>Foot Clone</b-form-checkbox>
        <b-form-checkbox v-model="noCollapse" :aria-describedby="ariaDescribedby" inline>No border collapse</b-form-checkbox>
      </b-form-group>
      <b-form-group label="Head Variant" label-cols-lg="2" v-slot="{ ariaDescribedby }">
        <b-form-radio-group
            v-model="headVariant"
            :aria-describedby="ariaDescribedby"
            class="mt-lg-2"
        >
          <b-form-radio :value="null" inline>None</b-form-radio>
          <b-form-radio value="light" inline>Light</b-form-radio>
          <b-form-radio value="dark" inline>Dark</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
      <b-form-group label="Table Variant" label-for="table-style-variant" label-cols-lg="2">
        <b-form-select
            id="table-style-variant"
            v-model="tableVariant"
            :options="tableVariants"
        >
          <template #first>
            <option value="">-- None --</option>
          </template>
        </b-form-select>
      </b-form-group>
    </template>

    <b-table
        :striped="striped"
        :bordered="bordered"
        :borderless="borderless"
        :outlined="outlined"
        :small="small"
        :hover="hover"
        :dark="dark"
        :fixed="fixed"
        :foot-clone="footClone"
        :no-border-collapse="noCollapse"
        :items="items"
        :fields="fields"
        :head-variant="headVariant"
        :table-variant="tableVariant"
    >
      <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>
      <template #cell(imgURL)="data">
        <b-img
            :src="data.item.imgURL"
            fluid alt="Responsive image"
            style="height: 300px"
        />
      </template>
      <template #cell(docURL)="data">
        <b-icon
            v-if="data.item.docURL"
            icon="file-pdf-fill"
            scale="2"
            variant="warning"/>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import TimeAgo from "vue2-timeago";
import Spreadsheet from "@/components/common/spreadsheet";
export default {
  name: "Admin_TableResources_Here",
  props: {
    profile: {
      type: Object,
      default: () => { return {}}
    },
    items: {
      type: Array,
      default: () => { return []}
    },
    fields: {
      type: Array,
      default: () => { return []}
    },
  },
  components: {
    TimeAgo,
    Spreadsheet,
  },
  computed: {
    ...mapGetters({
      allTools: "admin/tools",
      allCompanies: "admin/companies"
    }),
    filteredFields() {
      return this.fields && Array.isArray(this.fields)
        ? this.fields.filter(aField => {
            return aField.isAvail;
          })
        : [];
    },
    columns() {
      return this.convertFieldToColumn(this.fields);
    },
    content() {
      return this.convertItemsToContent(this.publishings);
    }
  },
  mounted() {},
  methods: {
    getTools() {
      this.$store.dispatch("admin/getTools").then((res)=>{

      }).catch((rej)=>{

      });
    },
    handleOpenFormSideBar() {
      this.formSBModel = true;
    },
    handleCloseFormSideBar() {
      this.formSBModel = false;
    },
    getCompanies() {
      this.$store.dispatch("admin/getCompanies");
    },
    showDeleteTool(resource) {
      this.selectedMode='del';
      this.selectedResource = resource;
      this.$bvModal.show(this.modalId);
    },
    handleEditToolClick(resource) {
      this.selectedResource = resource;
      this.selectedMode ="edit";
      this.$bvModal.show(this.modalId);
    },
    showMore(id) {
      this.$set(this.readMore, id, true);
    },
    showLess(id) {
      this.$set(this.readMore, id, false);
    },
    /******* SOREADSHEET ****/
    convertFieldToColumn(fields) {
      const columns = JSON.parse(JSON.stringify(fields));

      columns.forEach(aColumn => {
        if (aColumn.hasOwnProperty("key")) {
          aColumn.value = aColumn.key;
          delete aColumn["key"];
        }
        if (aColumn.hasOwnProperty("sortable")) {
          delete aColumn["sortable"];
        }
        if (aColumn.hasOwnProperty("tdClass")) {
          delete aColumn["tdClass"];
        }
        if (aColumn.hasOwnProperty("formatter")) {
          delete aColumn["formatter"];
        }
        if (aColumn.hasOwnProperty("isAvail")) {
          delete aColumn["isAvail"];
        }
      });

      return columns;
    },
    convertItemsToContent() {
      const content = [];
      if (this.resources && Array.isArray(this.resources)) {
        let index = 1;
        this.resources.forEach(anItem => {
          const thisContent = {
            Index: index++,
            id: anItem.id,
            name: anItem.name,
            imgURL: `=IMAGE(${anItem.imgURL})`,
            description: anItem.description,
            status: anItem.status,
            price: anItem.price,
            _created_at: this.formatDate(anItem._created_at),
            _updated_at: this.formatDate(anItem._updated_at)
          };

          //COMPANY
          if (anItem.company) {
            thisContent.company = `${anItem.company.name}(${anItem.company.email})`;
          }
          content.push(thisContent);
        });
      }
      return content;
    },
    /*****************/
    getStatus(status) {
      if (status == "active") {
        return "Active";
      } else return "In Active";
    },
    getStatusColor(status) {
      if (status == "active") {
        return "#4BB543";
      } else return "#FF0000";
    },
    formatDate(date) {
      return date
        ? moment(date.toDate()).format("MMMM DD, YYYY h:MM a")
        : "N/A";
    },
    toggleSphere(e) {
      if (this.formTool.spheres.includes(e)) {
        let index = this.formTool.spheres.indexOf(e);
        this.formTool.spheres.splice(index, 1);
      } else {
        this.formTool.spheres.push(e);
      }
    },
    hideDeleteTool() {
      this.formTool = null;
      this.$bvModal.hide(this.modalId);
    },
    deleteTool() {
      this.$store
        .dispatch("admin/deleteTool", {
          resourceId: this.selectedResource.resourceId,
          deletedBy: this.profile.userId
        })
        .then(res => {
          this.$bvModal.hide(this.modalId);
          this.getTools();
        });
    },
  },
  data() {
    return {
      production:true,
      readMore: {},
      modalId: "admin-resources",
      resourceVideo: "resource-video",
      searchStr: "",
      input: "",
      selectedResource: null,
      selectedMode: null,
      /*TABLE  DATA */
      tableVariants: [
        'primary',
        'secondary',
        'info',
        'danger',
        'warning',
        'success',
        'light',
        'dark'
      ],
      striped: false,
      bordered: false,
      borderless: false,
      outlined: false,
      small: false,
      hover: false,
      dark: false,
      fixed: false,
      footClone: false,
      headVariant: null,
      tableVariant: '',
      noCollapse: false
    };
  }
};
</script>

<style lang="scss" scoped>
.add-resource {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: var(--theme-color);
  cursor: pointer;
  position: relative;
}
.add-resource {
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
  .btn-round-fill {
    max-width: 160px;
    width: 100%;
  }
  .upload-btn {
    margin: 10px;
  }
  input {
    margin-top: 5px;
    margin-bottom: 10px;
  }
  h3 {
    margin-bottom: 0;
    margin-top: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    color: #474d52;
    text-align: center;
  }
}
.del-user {
  .warning-msg {
    margin: 24px 0;
    p {
      text-align: center;
      margin: 0;
    }
  }
  .btn-round-fill {
    background-color: #ef5c4a;
    border-color: #ef5c4a;
  }
  .btn-simple {
    color: #ef5c4a;
    font-weight: bold;
  }
}

.search {
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
}
.card-resource {
  box-shadow: none;
}
.resources {
  margin-top: 20px;
  .card {
    border: none;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    .card-text {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      display: flex;
      align-items: center;
      color: #474d52;
    }
  }

  .card-header {
    display: grid;
    grid-template-columns: 1fr 30px;
    align-items: center;
    padding: 0;
    .edit,
    .delete {
      display: none;
      cursor: pointer;
    }
    .btn-collapse {
      padding: 24px;
      text-align: left;
      box-shadow: none;
    }
    &.active {
      grid-template-columns: 1fr 30px 30px 30px;
      .edit,
      .delete {
        display: block;
      }
      .btn-collapse {
        padding-bottom: 0px;
      }
    }

    border: none;
    box-shadow: none;
    background: none;
  }
}
.actions {
  display: flex;
  justify-content: space-evenly;
}
.status {
  margin-top: 0.5rem;
  display: flex;
  flex-direction: column;
  .status-btn {
    display: inline-block;
    margin-right: 15px;
    width: 105px;
    height: 21px;
    font-family: Nunito;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #ffffff;
    background: var(--theme-color);
    text-align: center;
    border: none;
    border-radius: 3px;
  }
}
.resource-image {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
.areas {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  & > div {
    width: 60px;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #8d99a0;
    }
    svg {
      cursor: pointer;
    }
  }
}
#description {
  border-radius: 5px;
}
#resource-video {
  visibility: hidden;
  position: absolute;
}
.inline-form {
  display: flex;
  justify-content: space-around;
}
.resource-images {
  display: flex;
  flex-wrap: wrap;
  .resource-image {
    margin-left: 15px;
    width: 115px;
    height: 170px;
    border-radius: 5px;
  }
}
.companies {
  cursor: pointer;
  padding: 5px 15px;
  border-bottom: 1px solid #000;
  width: 250px;
  span {
    font-weight: bold;
  }
  .company-image {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 20px;
  }
}
.resource-video {
  width: 250px;
  height: 185px;
  border-radius: 15px;
}
</style>
